import { motion } from 'framer-motion'
import { Button } from '@/components/ui/button.jsx'
import { TypographySmall } from '@/components/ui/typography'

export const NewVersionMessage = () => {
    return (
        <motion.div
            initial={{ opacity: 0, bottom: "-100px" }}
            animate={{ opacity: 1, bottom: 0 }}
            transition={{ type: "tween", duration: 0.5 }}
            className="fixed bottom-0 right-0 m-4 p-5 rounded-xl z-40 border border-white/10 flex flex-col justify-center items-center gap-3 bg-black/50 backdrop-blur-xl shadow-2xl shadow-black/30 overflow-hidden"
        >
            <motion.div
                className="absolute inset-0 bg-gradient-to-r from-transparent via-white/50 to-transparent z-10 pointer-events-none"
                initial={{ x: '-100%' }}
                animate={{ x: '100%' }}
                transition={{ duration: 1.5, ease: 'easeInOut', repeat: Infinity, repeatDelay: 2 }}
            />
            <TypographySmall className="text-white">
                New version available!
            </TypographySmall>
            <Button className="w-full" onClick={() => window.location.reload()}>
                Click here to refresh the page
            </Button>

        </motion.div>
    )
}